import React from 'react';
import {
  Box,
  Container,
  Grid,
  Modal,
  Backdrop,
  Fade
} from '@mui/material';
// import { Pagination } from '@mui/lab';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import InvoiceCard from './InvoiceCard';
import getInvoices from '../../../requests/getInvoices';
import previewInvoice from '../../../requests/previewInvoice';

const useStyles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  caseCard: {
    height: '100%'
  },
  modal: {
    position: 'absolute !important',
    display: 'inline-flex',
    height: '100%',
    width: '100%',
    overflow: 'scroll',
    top: '50px !important',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
});

class InvoiceList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      invoices: [],
      roles: [],
      preview: ''
    };
  }

  componentDidMount = async () => {
    let response = await getInvoices();
    const { keycloak } = this.props;
    response = _.map(response, (res, key) => { return { id: key, ...res }; });
    response = _.orderBy(response, ['last_updated'], ['desc']);
    this.setState({ invoices: response, roles: _.get(keycloak, ['realmAccess', 'roles']) });
  }

  getPreviewInvoice = async (id) => {
    const preview = await previewInvoice(id);
    this.setState({ preview });
  }

  render() {
    const { classes } = this.props;
    const { invoices, roles, preview } = this.state;

    return (
      <Page
        className={classes.root}
        title="Invoices"
      >
        <Container maxWidth={false}>
          <Toolbar roles={roles} />
          <Box mt={3}>
            <Grid
              container
              spacing={3}
            >
              {_.map(invoices, (invoice) => (
                <Grid
                  item
                  key={invoice.id}
                  lg={4}
                  md={6}
                  xs={12}
                >
                  <InvoiceCard
                    className={classes.caseCard}
                    invoice={invoice}
                    roles={roles}
                    getPreviewInvoice={this.getPreviewInvoice}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={!_.isEmpty(preview)}
            onClose={() => this.setState({ preview: '' })}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={!_.isEmpty(preview)}>
              <div className={classes.paper}>
                {/* eslint-disable-next-line */}
                <div dangerouslySetInnerHTML={{ __html: preview }} />
              </div>
            </Fade>
          </Modal>
        </Container>
      </Page>
    );
  }
}
InvoiceList.propTypes = {
  classes: PropTypes.any,
  keycloak: PropTypes.any,
};

export default withStyles(useStyles)(InvoiceList);
